var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "tab-container" } },
    [
      _c(
        "b-tabs",
        {
          attrs: {
            type: "is-toggle",
            expanded: _vm.expanded,
            animated: _vm.animated,
          },
          on: { input: _vm.callback },
        },
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "b-tab-item",
            {
              key: `${option}-${i}`,
              attrs: {
                label: option.label,
                icon: option.icon,
                value: option.label,
                visible: option.show,
                "header-class": "text-not-underline",
              },
            },
            [
              _vm._t(i, function () {
                return [_vm._v(" Slot " + _vm._s(option.label))]
              }),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }